import React, { useState } from "react"
import SvgSupport from "@Components/CustomIcon/SvgSupport"
import CustomSettingTitle from "@Components/CustomSettingTitle/CustomSettingTitle"
import { View } from "react-native"
import { Divider, List } from "react-native-paper"
import SvgNext from "@Components/CustomIcon/SvgNext"
import { useNavigation } from "@react-navigation/core"
import { useSetRecoilState } from "recoil"
import { navigationAtom } from "@Recoil/navigationAtom"
import styles from "./styles"
import { Spacer } from "../../../Components/Space"

const Bibliography = () => {
    const navigation = useNavigation()
    const setNavigationState = useSetRecoilState(navigationAtom)
    const [loading, setLoading] = useState(false)
    const rightIcon = () => <List.Icon style={{ paddingLeft: 40 }} icon={() => <SvgNext />} />

    const navigateTo = (nextScreen) => {
        setNavigationState(nextScreen)
        navigation.navigate(nextScreen)
    }

    const supportItems = [
        {
            title: "Sources",
            description: "Consultez la liste",
            onPress: () => navigateTo("BibliographySources")
        }
    ]

    return (
        <View style={styles.container}>
            <CustomSettingTitle title="Références / Bibliographie" subTitle="" icon={<SvgSupport />} />

            <View style={[styles.content, { top: -100 }]}>
                <List.Section>
                    {supportItems.map((item, index) => {
                        const showDivider = index !== supportItems.length - 1
                        return (
                            <View key={index}>
                                <List.Item
                                    style={styles.item}
                                    title={item.title}
                                    titleStyle={styles.titleStyle}
                                    description={item.description}
                                    descriptionStyle={styles.descriptionStyle}
                                    right={rightIcon}
                                    onPress={() => (index > 0 ? item.onPress() : loading ? {} : item.onPress())}
                                />
                                {showDivider && <Divider style={styles.divider} />}
                            </View>
                        )
                    })}
                </List.Section>
            </View>
        </View>
    )
}

export default Bibliography
